chatClient.controller('chatCtrl', [
    '$window',
    '$rootScope',
    '$scope',
    '$interval',
    '$timeout',
    '$compile',
    '$filter',
    'socketService',
    'attendeeService',
    'meetingService',
    'analyticsWrapperService',
    'logService',
    'attendeeListService',
    'helperService',
    'configService',
    'inputService',
    'customChatService',
    'brandingService',
    'notificationService',
    'cookieService',
    'localizationService',
    'notificationTranslationService',
    /**
     * @param notificationTranslationService {NotificationTranslationService}
     */
    function (
        $window,
        $rootScope,
        $scope,
        $interval,
        $timeout,
        $compile,
        $filter,
        socketService,
        attendeeService,
        meetingService,
        analyticsWrapperService,
        logService,
        attendeeListService,
        helperService,
        configService,
        inputService,
        customChatService,
        brandingService,
        notificationService,
        cookieService,
        localizationService,
        notificationTranslationService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('chatCtrl');

        self.sendChat = sendChat;
        self.receiveChat = receiveChat;
        self.showAttendeeNotHereAlert = showAttendeeNotHereAlert;
        self.onDownloadClick = onDownloadClick;
        self.getMessageClass = getMessageClass;
        self.messages = [];
        self.name = attendeeService.getScreenName();
        self.attendantId = attendeeService.getAttendantId();
        self.email = attendeeService.getEmail();
        self.userIdentifier = attendeeService.getUserIdentifier();
        self.isTrusted = attendeeService.getIsTrusted();
        self.scrollToBottom = scrollToBottom;
        self.isAtBottomMostOffset = isAtBottomMostOffset;
        self.imageURL = attendeeService.getImageURL();
        self.chatText = '';
        self.clearChats = clearChats;
        self.setInputFocus = setInputFocus;
        self.focusInput = true;
        self.getAttendees = getAttendees;
        self.getAttendeesListForPrivateChat = getAttendeesListForPrivateChat;
        self.orderByHostsOnTopThenAlpha = orderByHostsOnTopThenAlpha;
        self.filterChatNotificationForWebinarAttendee = filterChatNotificationForWebinarAttendee;
        self.chatFocused = chatFocused;
        self.chatBlurred = chatBlurred;
        self.generateCustomMessage = generateCustomMessage;
        self.clearCustomChatList = clearCustomChatList;
        self.refreshCustomChatList = refreshCustomChatList;
        self.setMessagesArray = setMessagesArray;
        self.hasScrollBarInChat = hasScrollBarInChat;

        self.onChatInputChange = onChatInputChange;
        self.onStoppedTyping = onStoppedTyping;
        self.cancelTypingTimeout = cancelTypingTimeout;
        self.sendTypingStateToServer = sendTypingStateToServer;
        self.getLengthOfAttendeesTypingList = getLengthOfAttendeesTypingList;
        self.getFirstMemberOfAttendeesTypingList = getFirstMemberOfAttendeesTypingList;
        self.clearTypingState = clearTypingState;
        self.clearMeetingChat = clearMeetingChat;
        self.canClearMeetingChat = canClearMeetingChat;

        self.attendeesTyping = {};
        self.isTyping = false;

        self.onE2EEEnabled = onE2EEEnabled;
        self.notificationTranslationService = notificationTranslationService;

        //Private Chat
        self.privateChat = false; //If true, messages sent from this client will be marked as private by Mtg Server
        self.privateChatOnly = false; //If true, this client will not be able to send non-private messages
        self.lastPrivateChatValue = false; //Used to remember private chat state, in case Webinar client gets demoted to attendee and promoted back to presenter
        self.respondId = 0; //attendantId of recipient of private message
        self.respondantName = ''; //Name of recipient of private message
        self.privateChatFilter = '';
        self.isPrivateResponseTagVisible = isPrivateResponseTagVisible;
        self.isPrivateCheckboxVisible = isPrivateCheckboxVisible;
        self.onPrivateCheckboxUpdated = onPrivateCheckboxUpdated;
        self.isPrivateDropdownVisible = isPrivateDropdownVisible;
        self.setResponse = setResponse;
        self.clearResponse = clearResponse;
        self.showMessageResponse = showMessageResponse;
        self.getPrivateNameDisplay = getPrivateNameDisplay;
        self.getMessageRespondantName = getMessageRespondantName;
        self.filterByNameStartsWith = filterByNameStartsWith;
        self.onPrivateChatSearchSubmit = onPrivateChatSearchSubmit;
        self.onPrivateChatDropdownOpened = onPrivateChatDropdownOpened;
        self.privateSearchInputFocus = false;

        //Emojis
        self.updateCurrentEmoji = updateCurrentEmoji;
        self.initEmojis = initEmojis;
        self.enterEmoji = enterEmoji;
        self.emojis = [];
        self.currentEmoji = ':smile:';

        //disabling/enabling Desktop Notification pop-ups
        self.disableChatNotifications = false;
        self.toggleChatNotifications = toggleChatNotifications;

        self.getYouText = getYouText;
        self.getEveryoneText = getEveryoneText;
        self.cachedYouText = null;
        self.cachedEveryoneText = null;

        $scope.$on('chat-message', onChatMessage);
        $scope.$on('chat-history', onChatHistory);
        $scope.$on('onShowChatTab', onShowChatTab);
        $scope.$on('cleared-webinar-chat-messages', onClearedChatMessages);
        $scope.$on('cleared-meeting-chat-messages', onClearedChatMessages);
        $scope.$on('node-reconnected', onNodeReconnected);
        $scope.$on('attendee-list-updated', digest);
        $scope.$on('presenter-status-updated', onPresenterStatusUpdated);
        $scope.$on('demoted-to-attendee', onDemotedToAttendee);
        $scope.$on('webinar-options-updated', onWebinarOptionsUpdated);
        $scope.$on('attendee-type-updated', onAttendeeTypeUpdated);
        $scope.$on('attendees-typing-list-updated', onAttendeesTypingListUpdated);
        $scope.$on('meeting-private-chat-disabled', onMeetingPrivateChatDisabled);
        $scope.$on('e2ee-enabled', self.onE2EEEnabled);

        init();

        ////////////////////////

        function init() {
            logger.debug('init chatCtrl');

            if (meetingService.canUseMeetingChat()) {
                logger.log('manually retrieving chat history');

                var msgObj = {
                    message: 'chat-history',
                    callback: function (chatList) {
                        logger.log('received chatlist: ' + chatList);
                        self.setMessagesArray(chatList);
                        self.scrollToBottom();
                    }
                };

                //the init is only called if the chat tab is clicked, so it's visible so we can go ahead an do a retrieve
                //without checking for webinar visibility
                socketService.send(msgObj);
            }

            if (
                !attendeeService.getIsPresenter() &&
                meetingService.isWebinarAttendee() &&
                meetingService.getWebinarOptions().privateChatOnly
            ) {
                self.lastPrivateChatValue = self.privateChat;
                self.privateChat = true;
                self.privateChatOnly = true;
                digest();
            }

            if (!meetingService.isWebinar()) {
                //Need to wait for element to get created before attaching listener (due to ng-if on the element)
                $timeout(function () {
                    $window.$('#private-chat-container').on('shown.bs.dropdown', self.onPrivateChatDropdownOpened);
                }, 500);
            }
        }

        //Host of Webinar turns chatdesktop notifications on or off
        function toggleChatNotifications() {
            notificationService.determineStateOfChatNotifications(self.disableChatNotifications);
            self.setInputFocus(true);
        }

        // Returns true if the current user is the intended recipient of a private message,
        // including concurrent sessions (same user logged in on multiple devices with the same email).
        function isCurrentUserRecipient(respondId) {
            if (!respondId) {
                return false;
            }
            if (respondId === self.attendantId) {
                return true;
            }
            var recipientAtt = attendeeListService.findAttendee(respondId);
            if (recipientAtt) {
                if (self.email && recipientAtt.email && recipientAtt.email === self.email) {
                    return true;
                }
                if (
                    self.userIdentifier &&
                    recipientAtt.userIdentifier &&
                    recipientAtt.userIdentifier === self.userIdentifier
                ) {
                    return true;
                }
            }
            return false;
        }

        //For Meetings with Private Chat enabled
        function getMessageRespondantName(message) {
            if (!message) {
                logger.warn('getMessageRespondantName', 'invalid message param');
                return '';
            }

            if (isCurrentUserRecipient(message.respondId)) {
                return self.getYouText();
            } else if (message.respondantName) {
                return message.respondantName;
            } else {
                return self.getEveryoneText();
            }
        }

        function filterByNameStartsWith(attendee) {
            if (!attendee || !attendee.screenName) {
                return false;
            }

            return $filter('nameStartsWith')(attendee.screenName, self.privateChatFilter || '');
        }

        function onPrivateChatSearchSubmit() {
            if ($window.$('#private-chat-container ul').children().length === 1) {
                //If one result in Private Chat search, hitting 'enter' should select that single search item
                $window.$('#private-chat-container ul').children().trigger('click');
            }
        }

        function onPrivateChatDropdownOpened() {
            self.privateSearchInputFocus = true;
            self.privateChatFilter = '';

            //Scroll to selected attendee in the dropdown
            if (self.respondId && $window.$('#pc_' + self.respondId).get(0)) {
                var heightOfSearchInput = $window.$('#private-search-input').get(0).offsetHeight;
                var offsetTopOfSelectedAttendee =
                    $window.$('#pc_' + self.respondId).get(0).offsetTop - heightOfSearchInput;
                $window.$('#private-chat-container ul').animate({ scrollTop: offsetTopOfSelectedAttendee });
            }

            digest();
        }

        function getPrivateNameDisplay(message) {
            if (!message || !message.isPrivate) {
                return '';
            }

            if (message.respondantName && message.respondId) {
                //Private message for specific attendee

                if (isCurrentUserRecipient(message.respondId)) {
                    return localizationService.translate('ATTENDEE_LIST.CHAT.PRIVATE_TO_YOU');
                } else {
                    return localizationService.translate('ATTENDEE_LIST.CHAT.PRIVATE_TO_SOMEONE', {
                        name: message.respondantName
                    });
                }
            } else if (meetingService.isWebinar()) {
                return localizationService.translate('ATTENDEE_LIST.CHAT.PRIVATE_TO_PRESENTERS');
            } else {
                //This case should not happen in practice
                logger.error(
                    'getPrivateNameDisplay',
                    'Invalid respondantName and respondId',
                    message.respondantName,
                    message.respondId
                );
                return '';
            }
        }

        function getEveryoneText() {
            if (!self.cachedEveryoneText) {
                self.cachedEveryoneText = localizationService.translate('COMMON.EVERYONE_CAP');
            }

            return self.cachedEveryoneText;
        }

        function getYouText() {
            if (!self.cachedYouText) {
                self.cachedYouText = localizationService.translate('COMMON.YOU_TEXT');
            }

            return self.cachedYouText;
        }

        function isPrivateResponseTagVisible() {
            return attendeeService.getIsPresenter() && self.respondId > 0;
        }

        function isPrivateCheckboxVisible() {
            return !attendeeService.getIsPresenter();
        }

        function onPrivateCheckboxUpdated() {
            self.setInputFocus(true);
        }

        function onMeetingPrivateChatDisabled() {
            self.clearResponse();
        }

        function isPrivateDropdownVisible() {
            if (meetingService.isWebinar()) {
                return attendeeService.getIsPresenter() && self.respondId === 0;
            } else {
                return meetingService.canUseMeetingPrivateChat();
            }
        }

        function setResponse(message) {
            if (meetingService.isMeeting() && !meetingService.canUseMeetingPrivateChat()) {
                return;
            }

            //prevent send private message to self
            const identifier = message.userIdentifier;
            const matchesSelf = identifier === self.userIdentifier || identifier === self.email;

            if (identifier && matchesSelf) {
                return;
            }

            //Clear typing state when Private Message recipient is chosen
            //so that new typing event can be detected and sent to new recipient
            self.clearTypingState();

            self.privateChat = true;
            self.respondantName = message.name;
            self.respondId = message.id;
            self.setInputFocus(true);
            self.privateChatFilter = '';

            digest();
        }

        function clearResponse(setInputFocus) {
            self.clearTypingState();

            self.privateChat = false;
            self.respondantName = '';
            self.respondId = 0;
            self.privateChatFilter = '';

            if (setInputFocus) {
                self.setInputFocus(true);
            }

            digest();
        }

        function showMessageResponse(message, index) {
            var msgOwner = attendeeListService.findAttendee(message.id);

            if (!attendeeService.getIsPresenter()) {
                return false;
            }

            //If private message sent from attendee, show reponse button
            if (msgOwner && msgOwner.attendeeType === 'attendee') {
                return message.isPrivate ? true : false;
            }

            //If private message was intended for just you, show response button
            if (message.isPrivate && message.respondId && isCurrentUserRecipient(message.respondId)) {
                return true;
            }

            return false;
        }

        function getMessageClass(message, index) {
            var classes = [];
            if (message.notification) {
                classes.push('notification');

                if (index > 0 && self.messages[index - 1].notification) {
                    classes.push('continued-notification');
                }

                return classes.join(' ');
            }

            var curUserIsSender =
                message.id === self.attendantId ||
                (message.userIdentifier && self.userIdentifier && message.userIdentifier === self.userIdentifier) ||
                (message.userIdentifier && self.email && message.userIdentifier === self.email) ||
                (message.email && self.email && message.email === self.email);

            if (message.isPrivate) {
                classes.push('private');

                //If current client is not Presenter,
                //they should only be able to see private messages meant for them
                //Private messages for other attendees will be hidden
                if (!attendeeService.getIsPresenter()) {
                    var curUserIsRecipient = isCurrentUserRecipient(message.respondId);

                    if (!curUserIsSender && !curUserIsRecipient) {
                        classes.push('hidden-msg');
                        return classes.join(' ');
                    }
                }
            }

            if (curUserIsSender) {
                classes.push('self');
            } else {
                classes.push('other');
            }

            var isCurMessageContinued = index > 0 && self.messages[index - 1].id === message.id;
            var isNextMessageContinued = self.messages[index + 1] && self.messages[index + 1].id === message.id;

            var isPrevMessagePrivate = index > 0 && self.messages[index - 1] && self.messages[index - 1].isPrivate;
            var isCurMessagePrivate = message.isPrivate;
            var isNextMessagePrivate = self.messages[index + 1] && self.messages[index + 1].isPrivate;

            //If previous and current messages are not of same privacy type,
            //do not consider this a 'continued' message
            if (isPrevMessagePrivate !== isCurMessagePrivate) {
                isCurMessageContinued = false;
            }

            //If current and next messages are not of same privacy type,
            //do not consider next message a 'continued' message
            if (isCurMessagePrivate !== isNextMessagePrivate) {
                isNextMessageContinued = false;
            }

            //Do not count as 'continued' messages if
            //they are private and meant for different attendees
            if (isPrevMessagePrivate && isCurMessagePrivate) {
                if (self.messages[index - 1].respondId !== self.messages[index].respondId) {
                    isCurMessageContinued = false;
                }
            }

            //Do not count as 'continued' messages if
            //they are private and meant for different attendees
            if (isCurMessagePrivate && isNextMessagePrivate) {
                if (self.messages[index].respondId !== self.messages[index + 1].respondId) {
                    isNextMessageContinued = false;
                }
            }

            //Continued Message
            if (isCurMessageContinued) {
                classes.push('continued');
            }

            return classes.join(' ');
        }

        /**
         * @name sendChat
         * @function
         * @memberOf  angular_module.chatClient.chatCtrl
         * @description Sends chat
         */
        function sendChat(chatMessage, appGenerated) {
            if (!chatMessage) {
                return;
            }

            var chatMessageObject = {
                message: chatMessage,
                isPrivate: self.privateChat,
                autoGenerated: false
            };

            if (appGenerated) {
                chatMessageObject.appGenerated = appGenerated;
            }

            if (self.respondId > 0) {
                var privateMsgRecipient = attendeeListService.findAttendee(self.respondId);
                if (!privateMsgRecipient) {
                    self.showAttendeeNotHereAlert();
                    logger.log(
                        'Attempted to send Private Message to an attendee that is no longer in the meeting... returning'
                    );
                    return;
                }

                chatMessageObject.respondId = self.respondId;
            }

            var msgObj = {};
            msgObj.message = 'send-chat';
            msgObj.data = chatMessageObject;

            socketService.send(msgObj);
            self.chatText = '';
        }

        function receiveChat(receivedChatMessageObject) {
            var newMsg;
            if (receivedChatMessageObject.notification) {
                if (meetingService.isWebinarAttendee()) {
                    return;
                }
                newMsg = {
                    message: receivedChatMessageObject.message,
                    notification: true
                };

                //if the message is a notification, and it's translateable, then do that
                if (receivedChatMessageObject.translation && receivedChatMessageObject.translation.key) {
                    newMsg.message =
                        self.notificationTranslationService.translateNotification(receivedChatMessageObject);
                }
            } else {
                newMsg = {
                    id: receivedChatMessageObject.id,
                    message: receivedChatMessageObject.message,
                    name: receivedChatMessageObject.name,
                    filename: receivedChatMessageObject.filename,
                    time: receivedChatMessageObject.time,
                    email: receivedChatMessageObject.email,
                    imageURL: receivedChatMessageObject.imageURL,
                    autoGenerated: receivedChatMessageObject.autoGenerated,
                    isPrivate: receivedChatMessageObject.isPrivate,
                    respondantName: receivedChatMessageObject.respondantName,
                    respondId: receivedChatMessageObject.respondId,
                    fileDownloadContentId: receivedChatMessageObject.fileDownloadContentId,
                    senderSupportsPrivateMeetingChat: receivedChatMessageObject.senderSupportsPrivateMeetingChat,
                    userIdentifier: receivedChatMessageObject.userIdentifier || receivedChatMessageObject.email
                };
            }

            if (receivedChatMessageObject.appGenerated) {
                newMsg.appGenerated = receivedChatMessageObject.appGenerated;
            }

            var shouldScrollToBottom = self.isAtBottomMostOffset();
            self.messages.push(newMsg);
            self.generateCustomMessage(newMsg, self.messages.length - 1);
            digest();

            //logic for determining when to scrolldown
            if (shouldScrollToBottom) {
                self.scrollToBottom();
            }

            if (self.chatIntercept) {
                $rootScope.$broadcast('send-chat-intercept', {
                    message: receivedChatMessageObject.message,
                    direction: 'received'
                });
            }
        }

        function showAttendeeNotHereAlert() {
            var alertMsg;

            if (self.respondantName) {
                alertMsg = localizationService.translate('DIALOG.NAMED_ATTENDEE_IS_NO_LONGER_IN_THE_MEETING', {
                    name: self.respondantName
                });
            } else {
                alertMsg = localizationService.translate('DIALOG.THIS_ATTENDEE_IS_NO_LONGER_IN_THE_MEETING');
            }

            $window.swal({
                title: localizationService.translate('COMMON.OOPS_TEXT'),
                text: alertMsg,
                type: 'warning',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: brandingService.getBaseColor(),
                confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                allowOutsideClick: false
            });
        }

        function onDownloadClick(fileDownloadContentId) {
            if (fileDownloadContentId) {
                var msgObj = {
                    message: 'download-file-click',
                    data: {
                        id: self.attendantId,
                        contentId: fileDownloadContentId
                    }
                };
                socketService.send(msgObj);
            }
        }

        function isAtBottomMostOffset() {
            var chatList = $window.angular.element('#chat .chat-list')[0];
            return Math.abs(chatList.scrollHeight - chatList.scrollTop - chatList.clientHeight) <= 20;
        }

        function scrollToBottom() {
            digest();

            var chatList = $window.angular.element('#chat .chat-list')[0];
            chatList.scrollTop = chatList.scrollHeight;
        }

        function updateCurrentEmoji(newEmoji) {
            self.currentEmoji = newEmoji;
        }

        function initEmojis() {
            logger.debug('init emojis');
            self.emojis = [
                ':bowtie:',
                ':smile:',
                ':laughing:',
                ':blush:',
                ':smiley:',
                ':relaxed:',
                ':smirk:',
                ':heart_eyes:',
                ':kissing_heart:',
                ':kissing_closed_eyes:',
                ':flushed:',
                ':relieved:',
                ':satisfied:',
                ':grin:',
                ':wink:',
                ':stuck_out_tongue_winking_eye:',
                ':stuck_out_tongue_closed_eyes:',
                ':grinning:',
                ':kissing:',
                ':winky_face:',
                ':kissing_smiling_eyes:',
                ':stuck_out_tongue:',
                ':sleeping:',
                ':worried:',
                ':frowning:',
                ':anguished:',
                ':open_mouth:',
                ':grimacing:',
                ':confused:',
                ':hushed:',
                ':expressionless:',
                ':unamused:',
                ':sweat_smile:',
                ':sweat:',
                ':wow:',
                ':disappointed_relieved:',
                ':weary:',
                ':pensive:',
                ':disappointed:',
                ':confounded:',
                ':fearful:',
                ':cold_sweat:',
                ':persevere:',
                ':cry:',
                ':sob:',
                ':joy:',
                ':astonished:',
                ':scream:',
                ':neckbeard:',
                ':tired_face:',
                ':angry:',
                ':rage:',
                ':triumph:',
                ':sleepy:',
                ':yum:',
                ':mask:',
                ':sunglasses:',
                ':dizzy_face:',
                ':imp:',
                ':smiling_imp:',
                ':neutral_face:',
                ':no_mouth:',
                ':innocent:',
                ':alien:',
                ':yellow_heart:',
                ':blue_heart:',
                ':purple_heart:',
                ':heart:',
                ':green_heart:',
                ':broken_heart:',
                ':heartbeat:',
                ':heartpulse:',
                ':two_hearts:',
                ':revolving_hearts:',
                ':cupid:',
                ':sparkling_heart:',
                ':sparkles:',
                ':star:',
                ':star2:',
                ':dizzy:',
                ':boom:',
                ':collision:',
                ':anger:',
                ':exclamation:',
                ':question:',
                ':grey_exclamation:',
                ':grey_question:',
                ':zzz:',
                ':dash:',
                ':sweat_drops:',
                ':notes:',
                ':musical_note:',
                ':fire:',
                ':poop:',
                ':thumbsup:',
                ':thumbsdown:',
                ':ok_hand:',
                ':punch:',
                ':facepunch:',
                ':fist:',
                ':v:',
                ':wave:',
                ':hand:',
                ':raised_hand:',
                ':open_hands:',
                ':point_up:',
                ':point_down:',
                ':point_left:',
                ':point_right:',
                ':raised_hands:',
                ':pray:',
                ':point_up_2:',
                ':clap:',
                ':muscle:',
                ':metal:',
                ':walking:',
                ':runner:',
                ':running:',
                ':couple:',
                ':family:',
                ':two_men_holding_hands:',
                ':two_women_holding_hands:',
                ':dancer:',
                ':dancers:',
                ':ok_woman:',
                ':no_good:',
                ':information_desk_person:',
                ':raising_hand:',
                ':bride_with_veil:',
                ':person_with_pouting_face:',
                ':person_frowning:',
                ':bow:',
                ':couplekiss:',
                ':couple_with_heart:',
                ':massage:',
                ':haircut:',
                ':nail_care:',
                ':boy:',
                ':girl:',
                ':woman:',
                ':man:',
                ':baby:',
                ':older_woman:',
                ':older_man:',
                ':person_with_blond_hair:',
                ':man_with_gua_pi_mao:',
                ':man_with_turban:',
                ':construction_worker:',
                ':cop:',
                ':angel:',
                ':princess:',
                ':smiley_cat:',
                ':smile_cat:',
                ':heart_eyes_cat:',
                ':kissing_cat:',
                ':smirk_cat:',
                ':scream_cat:',
                ':crying_cat_face:',
                ':joy_cat:',
                ':pouting_cat:',
                ':japanese_ogre:',
                ':japanese_goblin:',
                ':see_no_evil:',
                ':hear_no_evil:',
                ':speak_no_evil:',
                ':guardsman:',
                ':skull:',
                ':feet:',
                ':lips:',
                ':kiss:',
                ':droplet:',
                ':ear:',
                ':eyes:',
                ':nose:',
                ':tongue:',
                ':love_letter:',
                ':bust_in_silhouette:',
                ':busts_in_silhouette:',
                ':speech_balloon:',
                ':thought_balloon:',
                ':feelsgood:',
                ':finnadie:',
                ':goberserk:',
                ':godmode:',
                ':hurtrealbad:',
                ':rage1:',
                ':rage2:',
                ':rage3:',
                ':rage4:',
                ':suspect:',
                ':trollface:',
                ':sunny:',
                ':umbrella:',
                ':cloud:',
                ':snowflake:',
                ':snowman:',
                ':zap:',
                ':cyclone:',
                ':foggy:',
                ':ocean:',
                ':cat:',
                ':dog:',
                ':mouse:',
                ':hamster:',
                ':rabbit:',
                ':wolf:',
                ':frog:',
                ':tiger:',
                ':koala:',
                ':bear:',
                ':pig:',
                ':pig_nose:',
                ':cow:',
                ':boar:',
                ':monkey_face:',
                ':monkey:',
                ':horse:',
                ':racehorse:',
                ':camel:',
                ':sheep:',
                ':elephant:',
                ':panda_face:',
                ':snake:',
                ':bird:',
                ':baby_chick:',
                ':hatched_chick:',
                ':hatching_chick:',
                ':chicken:',
                ':penguin:',
                ':turtle:',
                ':bug:',
                ':honeybee:',
                ':ant:',
                ':beetle:',
                ':snail:',
                ':octopus:',
                ':tropical_fish:',
                ':fish:',
                ':whale:',
                ':whale2:',
                ':dolphin:',
                ':cow2:',
                ':ram:',
                ':rat:',
                ':water_buffalo:',
                ':tiger2:',
                ':rabbit2:',
                ':dragon:',
                ':goat:',
                ':rooster:',
                ':dog2:',
                ':pig2:',
                ':mouse2:',
                ':ox:',
                ':dragon_face:',
                ':blowfish:',
                ':crocodile:',
                ':dromedary_camel:',
                ':leopard:',
                ':cat2:',
                ':poodle:',
                ':paw_prints:',
                ':bouquet:',
                ':cherry_blossom:',
                ':tulip:',
                ':four_leaf_clover:',
                ':rose:',
                ':sunflower:',
                ':hibiscus:',
                ':maple_leaf:',
                ':leaves:',
                ':fallen_leaf:',
                ':herb:',
                ':mushroom:',
                ':cactus:',
                ':palm_tree:',
                ':evergreen_tree:',
                ':deciduous_tree:',
                ':chestnut:',
                ':seedling:',
                ':blossom:',
                ':ear_of_rice:',
                ':shell:',
                ':globe_with_meridians:',
                ':sun_with_face:',
                ':full_moon_with_face:',
                ':new_moon_with_face:',
                ':new_moon:',
                ':waxing_crescent_moon:',
                ':first_quarter_moon:',
                ':waxing_gibbous_moon:',
                ':full_moon:',
                ':waning_gibbous_moon:',
                ':last_quarter_moon:',
                ':waning_crescent_moon:',
                ':last_quarter_moon_with_face:',
                ':first_quarter_moon_with_face:',
                ':moon:',
                ':earth_africa:',
                ':earth_americas:',
                ':earth_asia:',
                ':volcano:',
                ':milky_way:',
                ':partly_sunny:',
                ':octocat:',
                ':squirrel:',
                ':bamboo:',
                ':gift_heart:',
                ':dolls:',
                ':school_satchel:',
                ':mortar_board:',
                ':flags:',
                ':fireworks:',
                ':sparkler:',
                ':wind_chime:',
                ':rice_scene:',
                ':jack_o_lantern:',
                ':ghost:',
                ':santa:',
                ':christmas_tree:',
                ':gift:',
                ':bell:',
                ':no_bell:',
                ':tanabata_tree:',
                ':tada:',
                ':confetti_ball:',
                ':balloon:',
                ':crystal_ball:',
                ':cd:',
                ':dvd:',
                ':floppy_disk:',
                ':camera:',
                ':video_camera:',
                ':movie_camera:',
                ':computer:',
                ':tv:',
                ':iphone:',
                ':phone:',
                ':telephone:',
                ':telephone_receiver:',
                ':pager:',
                ':fax:',
                ':minidisc:',
                ':vhs:',
                ':sound:',
                ':speaker:',
                ':mute:',
                ':loudspeaker:',
                ':mega:',
                ':hourglass:',
                ':hourglass_flowing_sand:',
                ':alarm_clock:',
                ':watch:',
                ':radio:',
                ':satellite:',
                ':loop:',
                ':mag:',
                ':mag_right:',
                ':unlock:',
                ':lock:',
                ':lock_with_ink_pen:',
                ':closed_lock_with_key:',
                ':key:',
                ':bulb:',
                ':flashlight:',
                ':high_brightness:',
                ':low_brightness:',
                ':electric_plug:',
                ':battery:',
                ':calling:',
                ':email:',
                ':mailbox:',
                ':postbox:',
                ':bath:',
                ':bathtub:',
                ':shower:',
                ':toilet:',
                ':wrench:',
                ':nut_and_bolt:',
                ':hammer:',
                ':seat:',
                ':moneybag:',
                ':yen:',
                ':dollar:',
                ':pound:',
                ':euro:',
                ':credit_card:',
                ':money_with_wings:',
                ':e-mail:',
                ':inbox_tray:',
                ':outbox_tray:',
                ':envelope:',
                ':incoming_envelope:',
                ':postal_horn:',
                ':mailbox_closed:',
                ':mailbox_with_mail:',
                ':mailbox_with_no_mail:',
                ':door:',
                ':smoking:',
                ':bomb:',
                ':gun:',
                ':hocho:',
                ':pill:',
                ':syringe:',
                ':page_facing_up:',
                ':page_with_curl:',
                ':bookmark_tabs:',
                ':bar_chart:',
                ':chart_with_upwards_trend:',
                ':chart_with_downwards_trend:',
                ':scroll:',
                ':clipboard:',
                ':calendar:',
                ':date:',
                ':card_index:',
                ':file_folder:',
                ':open_file_folder:',
                ':scissors:',
                ':pushpin:',
                ':paperclip:',
                ':black_nib:',
                ':pencil2:',
                ':straight_ruler:',
                ':triangular_ruler:',
                ':closed_book:',
                ':green_book:',
                ':blue_book:',
                ':orange_book:',
                ':notebook:',
                ':notebook_with_decorative_cover:',
                ':ledger:',
                ':books:',
                ':bookmark:',
                ':name_badge:',
                ':microscope:',
                ':telescope:',
                ':newspaper:',
                ':football:',
                ':basketball:',
                ':soccer:',
                ':baseball:',
                ':tennis:',
                ':8ball:',
                ':rugby_football:',
                ':bowling:',
                ':golf:',
                ':mountain_bicyclist:',
                ':bicyclist:',
                ':horse_racing:',
                ':snowboarder:',
                ':swimmer:',
                ':surfer:',
                ':ski:',
                ':spades:',
                ':hearts:',
                ':clubs:',
                ':diamonds:',
                ':gem:',
                ':ring:',
                ':trophy:',
                ':musical_score:',
                ':musical_keyboard:',
                ':violin:',
                ':space_invader:',
                ':video_game:',
                ':black_joker:',
                ':flower_playing_cards:',
                ':game_die:',
                ':dart:',
                ':mahjong:',
                ':clapper:',
                ':memo:',
                ':pencil:',
                ':book:',
                ':art:',
                ':microphone:',
                ':headphones:',
                ':trumpet:',
                ':saxophone:',
                ':guitar:',
                ':shoe:',
                ':sandal:',
                ':high_heel:',
                ':lipstick:',
                ':boot:',
                ':shirt:',
                ':tshirt:',
                ':necktie:',
                ':womans_clothes:',
                ':dress:',
                ':running_shirt_with_sash:',
                ':jeans:',
                ':kimono:',
                ':bikini:',
                ':ribbon:',
                ':tophat:',
                ':crown:',
                ':womans_hat:',
                ':mans_shoe:',
                ':closed_umbrella:',
                ':briefcase:',
                ':handbag:',
                ':pouch:',
                ':purse:',
                ':eyeglasses:',
                ':fishing_pole_and_fish:',
                ':coffee:',
                ':tea:',
                ':sake:',
                ':baby_bottle:',
                ':beer:',
                ':beers:',
                ':cocktail:',
                ':tropical_drink:',
                ':wine_glass:',
                ':fork_and_knife:',
                ':pizza:',
                ':hamburger:',
                ':fries:',
                ':poultry_leg:',
                ':meat_on_bone:',
                ':spaghetti:',
                ':curry:',
                ':fried_shrimp:',
                ':bento:',
                ':sushi:',
                ':fish_cake:',
                ':rice_ball:',
                ':rice_cracker:',
                ':rice:',
                ':ramen:',
                ':stew:',
                ':oden:',
                ':dango:',
                ':egg:',
                ':bread:',
                ':doughnut:',
                ':custard:',
                ':icecream:',
                ':ice_cream:',
                ':shaved_ice:',
                ':birthday:',
                ':cake:',
                ':cookie:',
                ':chocolate_bar:',
                ':candy:',
                ':lollipop:',
                ':honey_pot:',
                ':apple:',
                ':green_apple:',
                ':tangerine:',
                ':lemon:',
                ':cherries:',
                ':grapes:',
                ':watermelon:',
                ':strawberry:',
                ':peach:',
                ':melon:',
                ':banana:',
                ':pear:',
                ':pineapple:',
                ':sweet_potato:',
                ':eggplant:',
                ':tomato:',
                ':corn:',
                ':house:',
                ':house_with_garden:',
                ':school:',
                ':office:',
                ':post_office:',
                ':hospital:',
                ':bank:',
                ':convenience_store:',
                ':love_hotel:',
                ':hotel:',
                ':wedding:',
                ':church:',
                ':department_store:',
                ':european_post_office:',
                ':city_sunrise:',
                ':city_sunset:',
                ':japanese_castle:',
                ':european_castle:',
                ':tent:',
                ':factory:',
                ':tokyo_tower:',
                ':japan:',
                ':mount_fuji:',
                ':sunrise_over_mountains:',
                ':sunrise:',
                ':stars:',
                ':themoreyouknow:',
                ':tmyk:',
                ':statue_of_liberty:',
                ':bridge_at_night:',
                ':carousel_horse:',
                ':rainbow:',
                ':ferris_wheel:',
                ':fountain:',
                ':roller_coaster:',
                ':ship:',
                ':speedboat:',
                ':boat:',
                ':sailboat:',
                ':rowboat:',
                ':anchor:',
                ':rocket:',
                ':airplane:',
                ':helicopter:',
                ':steam_locomotive:',
                ':tram:',
                ':mountain_railway:',
                ':bike:',
                ':aerial_tramway:',
                ':suspension_railway:',
                ':mountain_cableway:',
                ':tractor:',
                ':blue_car:',
                ':oncoming_automobile:',
                ':car:',
                ':red_car:',
                ':taxi:',
                ':oncoming_taxi:',
                ':articulated_lorry:',
                ':bus:',
                ':oncoming_bus:',
                ':rotating_light:',
                ':police_car:',
                ':oncoming_police_car:',
                ':fire_engine:',
                ':ambulance:',
                ':minibus:',
                ':truck:',
                ':train:',
                ':station:',
                ':train2:',
                ':bullettrain_front:',
                ':bullettrain_side:',
                ':light_rail:',
                ':monorail:',
                ':railway_car:',
                ':trolleybus:',
                ':ticket:',
                ':fuelpump:',
                ':vertical_traffic_light:',
                ':traffic_light:',
                ':warning:',
                ':construction:',
                ':beginner:',
                ':atm:',
                ':slot_machine:',
                ':busstop:',
                ':barber:',
                ':hotsprings:',
                ':checkered_flag:',
                ':crossed_flags:',
                ':izakaya_lantern:',
                ':moyai:',
                ':circus_tent:',
                ':performing_arts:',
                ':round_pushpin:',
                ':triangular_flag_on_post:',
                ':jp:',
                ':kr:',
                ':cn:',
                ':us:',
                ':fr:',
                ':es:',
                ':it:',
                ':ru:',
                ':gb:',
                ':uk:',
                ':de:',
                ':one:',
                ':two:',
                ':three:',
                ':four:',
                ':five:',
                ':six:',
                ':seven:',
                ':eight:',
                ':nine:',
                ':keycap_ten:',
                ':1234:',
                ':zero:',
                ':hash:',
                ':symbols:',
                ':arrow_backward:',
                ':arrow_down:',
                ':arrow_forward:',
                ':arrow_left:',
                ':capital_abcd:',
                ':abcd:',
                ':abc:',
                ':arrow_lower_left:',
                ':arrow_lower_right:',
                ':arrow_right:',
                ':arrow_up:',
                ':arrow_upper_left:',
                ':arrow_upper_right:',
                ':arrow_double_down:',
                ':arrow_double_up:',
                ':arrow_down_small:',
                ':arrow_heading_down:',
                ':arrow_heading_up:',
                ':leftwards_arrow_with_hook:',
                ':arrow_right_hook:',
                ':left_right_arrow:',
                ':arrow_up_down:',
                ':arrow_up_small:',
                ':arrows_clockwise:',
                ':arrows_counterclockwise:',
                ':rewind:',
                ':fast_forward:',
                ':information_source:',
                ':ok:',
                ':twisted_rightwards_arrows:',
                ':repeat:',
                ':repeat_one:',
                ':new:',
                ':top:',
                ':up:',
                ':cool:',
                ':free:',
                ':ng:',
                ':cinema:',
                ':koko:',
                ':signal_strength:',
                ':u5272:',
                ':u5408:',
                ':u55b6:',
                ':u6307:',
                ':u6708:',
                ':u6709:',
                ':u6e80:',
                ':u7121:',
                ':u7533:',
                ':u7a7a:',
                ':u7981:',
                ':sa:',
                ':restroom:',
                ':mens:',
                ':womens:',
                ':baby_symbol:',
                ':no_smoking:',
                ':parking:',
                ':wheelchair:',
                ':metro:',
                ':baggage_claim:',
                ':accept:',
                ':wc:',
                ':potable_water:',
                ':put_litter_in_its_place:',
                ':secret:',
                ':congratulations:',
                ':m:',
                ':passport_control:',
                ':left_luggage:',
                ':customs:',
                ':ideograph_advantage:',
                ':cl:',
                ':sos:',
                ':id:',
                ':no_entry_sign:',
                ':underage:',
                ':no_mobile_phones:',
                ':do_not_litter:',
                ':non-potable_water:',
                ':no_bicycles:',
                ':no_pedestrians:',
                ':children_crossing:',
                ':no_entry:',
                ':eight_spoked_asterisk:',
                ':eight_pointed_black_star:',
                ':heart_decoration:',
                ':vs:',
                ':vibration_mode:',
                ':mobile_phone_off:',
                ':chart:',
                ':currency_exchange:',
                ':aries:',
                ':taurus:',
                ':gemini:',
                ':cancer:',
                ':leo:',
                ':virgo:',
                ':libra:',
                ':scorpius:',
                ':sagittarius:',
                ':capricorn:',
                ':aquarius:',
                ':pisces:',
                ':ophiuchus:',
                ':six_pointed_star:',
                ':negative_squared_cross_mark:',
                ':a:',
                ':b:',
                ':ab:',
                ':o2:',
                ':diamond_shape_with_a_dot_inside:',
                ':recycle:',
                ':end:',
                ':on:',
                ':soon:',
                ':clock1:',
                ':clock130:',
                ':clock10:',
                ':clock1030:',
                ':clock11:',
                ':clock1130:',
                ':clock12:',
                ':clock1230:',
                ':clock2:',
                ':clock230:',
                ':clock3:',
                ':clock330:',
                ':clock4:',
                ':clock430:',
                ':clock5:',
                ':clock530:',
                ':clock6:',
                ':clock630:',
                ':clock7:',
                ':clock730:',
                ':clock8:',
                ':clock830:',
                ':clock9:',
                ':clock930:',
                ':heavy_dollar_sign:',
                ':copyright:',
                ':registered:',
                ':tm:',
                ':x:',
                ':heavy_exclamation_mark:',
                ':bangbang:',
                ':interrobang:',
                ':o:',
                ':heavy_multiplication_x:',
                ':heavy_plus_sign:',
                ':heavy_minus_sign:',
                ':heavy_division_sign:',
                ':white_flower:',
                ':100:',
                ':heavy_check_mark:',
                ':ballot_box_with_check:',
                ':radio_button:',
                ':link:',
                ':curly_loop:',
                ':wavy_dash:',
                ':part_alternation_mark:',
                ':trident:',
                ':black_square:',
                ':white_square:',
                ':white_check_mark:',
                ':black_square_button:',
                ':white_square_button:',
                ':black_circle:',
                ':white_circle:',
                ':red_circle:',
                ':large_blue_circle:',
                ':large_blue_diamond:',
                ':large_orange_diamond:',
                ':small_blue_diamond:',
                ':small_orange_diamond:',
                ':small_red_triangle:',
                ':small_red_triangle_down:',
                ':shipit:'
            ];
        }

        function enterEmoji(newEmoji) {
            analyticsWrapperService.eventTrack('Meeting - Chat - Inserted Emoji', {
                category: 'Chat'
            });

            self.chatText = self.chatText ? self.chatText + newEmoji : newEmoji;
            self.setInputFocus(true);
        }

        function clearChats() {
            var msgObj = {
                message: 'clear-webinar-chat-messages',
                data: {}
            };

            var preventClearAllMessagesAlert = cookieService.get('preventClearAllMessagesAlert');

            if (preventClearAllMessagesAlert) {
                socketService.send(msgObj);
                analyticsWrapperService.eventTrack('Meeting - Chat List - Clear all messages');
                return;
            }

            var promptTitle = localizationService.translate('ATTENDEE_LIST.CHAT.CLEAR_QUESTION');
            var promptMsg = localizationService.translate('ATTENDEE_LIST.CHAT.CLEAR_QUESTION_LONG');
            var doNotShowMsg = localizationService.translate('ATTENDEE_LIST.CHAT.CLEAR_DONT_SHOW');

            $window.swal(
                {
                    title: promptTitle,
                    text:
                        promptMsg +
                        '<br><br><span><label><input id="do-not-show-checkbox" type="checkbox" name="donotshow" value="true">' +
                        doNotShowMsg +
                        '</label></span>',
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: localizationService.translate('ATTENDEE_LIST.CHAT.CLEAR_NO'),
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('ATTENDEE_LIST.CHAT.CLEAR_YES'),
                    allowOutsideClick: true,
                    html: true
                },
                function (confirmed) {
                    if (confirmed) {
                        socketService.send(msgObj);
                        analyticsWrapperService.eventTrack('Meeting - Chat List - Clear all messages');

                        var checkbox = $window.angular.element('#do-not-show-checkbox');

                        if (checkbox.prop('checked')) {
                            cookieService.put('preventClearAllMessagesAlert', true, {
                                secure: true,
                                samesite: 'strict'
                            });
                        }
                    }
                }
            );
        }

        function onClearedChatMessages(evt, data) {
            self.messages = [];
            self.clearCustomChatList();

            if (data) {
                self.receiveChat(data);
            }

            digest();
        }

        function clearMeetingChat() {
            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            var msgTitle = localizationService.translate('SIDEBAR.CLEAR_CHAT_DIALOG.TITLE');
            var msgTxt = localizationService.translate('SIDEBAR.CLEAR_CHAT_DIALOG.BODY');
            var cancelTxt = localizationService.translate('COMMON.CANCEL_TEXT');
            var yesTxt = localizationService.translate('COMMON.YES_TEXT');

            $window.swal(
                {
                    title: closeButtonHtml + msgTitle,
                    text: msgTxt,
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: cancelTxt,
                    confirmButtonText: yesTxt,
                    confirmButtonColor: brandingService.getBaseColor(),
                    allowOutsideClick: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-delete.svg',
                    customClass: 'auto-size'
                },
                function (result) {
                    if (result) {
                        logger.log('chatCtrl - Clear meeting chat called');
                        socketService.send({
                            message: 'clear-meeting-chat-messages'
                        });
                    } else {
                        logger.log('chatCtrl - clear chat was canceled');
                    }
                }
            );
        }

        function onNodeReconnected() {
            if (meetingService.canUseMeetingChat()) {
                logger.log('chatCtrl - Node reconnected... retrieving chat history');

                socketService.send({
                    message: 'chat-history',
                    callback: function (chatList) {
                        self.clearCustomChatList();
                        self.setMessagesArray(chatList);
                        self.scrollToBottom();
                    }
                });
            }
        }

        function setInputFocus(focusVal) {
            self.focusInput = focusVal;
            digest();
        }

        function onChatInputMessage(event, msg) {
            if (meetingService.canUseMeetingChat()) {
                self.setInputFocus(true);
                self.chatText = (msg.final ? msg.final + (msg.interim ? ' ' : '') : '') + (msg.interim || '');
                if (msg.final && !msg.interim) {
                    if (msg.send !== false) {
                        self.sendChat(self.chatText, true);
                    }
                }
            }
        }

        function onChatMessage(event, receivedChatMessageObject) {
            if (meetingService.canUseMeetingChat()) {
                self.receiveChat(receivedChatMessageObject);
            }
        }

        function onChatHistory(event, chatList) {
            if (meetingService.canUseMeetingChat()) {
                logger.log('chat-history received');
                self.setMessagesArray(chatList);
                self.scrollToBottom();
            }
        }

        function filterChatNotificationForWebinarAttendee(msgs) {
            var filteredMessages = [];
            if (meetingService.isWebinarAttendee()) {
                if (msgs.length) {
                    msgs.forEach(function (msg) {
                        if (msg.notification !== true) {
                            filteredMessages.push(msg);
                        }
                    });
                }
            } else {
                return msgs;
            }
            return filteredMessages;
        }

        function onShowChatTab() {
            self.scrollToBottom();
        }

        function getAttendees() {
            var attendeeList = attendeeListService.getAttendeeList();
            var attendeesOnly = [];

            attendeeList.forEach(function (att) {
                if (att && att.attendeeType === 'attendee') {
                    attendeesOnly.push(att);
                }
            });

            return attendeesOnly;
        }

        function getAttendeesListForPrivateChat() {
            var attendeeList = attendeeListService.getAttendeeList();
            var listForPrivateChat = [];

            // De-duplicate tracker — only used for authenticated (trusted) attendees.
            // Unauthenticated attendees with the same email are distinct individuals
            // and must each appear as a separate recipient in the dropdown.
            var attendantInList = [];

            attendeeList.forEach(function (att) {
                var attUserIdentifier = att.userIdentifier || null;
                var attEmail = att.email || null;

                // De-duplicate only authenticated (trusted) attendees by userIdentifier/email.
                // Unauthenticated attendees with the same email are distinct individuals and
                // must each appear as a separate recipient in the dropdown.
                if (att.isTrusted) {
                    if (
                        (attUserIdentifier && attendantInList.includes(attUserIdentifier)) ||
                        (attEmail && attendantInList.includes(attEmail))
                    ) {
                        return;
                    }
                }

                // Exclude self.
                // For two authenticated (trusted) attendees, match by userIdentifier or email — this handles
                // the same user logged in concurrently on multiple devices.
                // In all other cases (untrusted self OR untrusted attendee), match only by exact attendantId:
                // an untrusted guest sharing the same email as an authenticated user is a different person.
                var isSelf = false;
                if (self.isTrusted && att.isTrusted) {
                    if (self.userIdentifier && attUserIdentifier && attUserIdentifier === self.userIdentifier) {
                        isSelf = true;
                    }
                    if (self.email && attEmail && attEmail === self.email) {
                        isSelf = true;
                    }
                } else {
                    if (att.attendantId === self.attendantId) {
                        isSelf = true;
                    }
                }

                if (!isSelf && att.supportsMeetingPrivateChat) {
                    listForPrivateChat.push(att);
                    // Only track in dedup list for trusted attendees
                    if (att.isTrusted) {
                        if (attUserIdentifier) {
                            attendantInList.push(attUserIdentifier);
                        }
                        if (attEmail) {
                            attendantInList.push(attEmail);
                        }
                    }
                }
            });

            return listForPrivateChat;
        }

        function onPresenterStatusUpdated(e, attendantId) {
            //attendantId = id of attendee who was promoted/demoted
            if (self.respondId === attendantId || self.attendantId === attendantId) {
                self.clearResponse();
            }
        }

        function onDemotedToAttendee() {
            self.clearResponse();

            if (meetingService.isWebinarAttendee() && meetingService.getWebinarOptions().privateChatOnly) {
                self.lastPrivateChatValue = self.privateChat;
                self.privateChat = true;
                self.privateChatOnly = true;
            }

            digest();
        }

        function onAttendeeTypeUpdated() {
            self.refreshCustomChatList();
        }

        function onChatInputChange() {
            if (!helperService.getIsRedesign()) {
                return;
            }

            if (!self.isTyping) {
                self.isTyping = true;
                digest();

                self.cancelTypingTimeout();
                self.sendTypingStateToServer();
            }
        }

        function onStoppedTyping() {
            if (!helperService.getIsRedesign()) {
                return;
            }

            self.cancelTypingTimeout();

            self.typingTimeout = $timeout(function () {
                self.typingTimeout = null;
                self.isTyping = false;

                self.sendTypingStateToServer();
            }, 2000); //Arbitrary 2-second buffer after last key entered
        }

        function cancelTypingTimeout() {
            if (!helperService.getIsRedesign()) {
                return;
            }

            if (self.typingTimeout) {
                $timeout.cancel(self.typingTimeout);
                self.typingTimeout = null;
            }
        }

        function sendTypingStateToServer() {
            if (!helperService.getIsRedesign()) {
                return;
            }

            socketService.send({
                message: 'attendee-typing-updated',
                data: {
                    isTyping: self.isTyping,
                    respondId: self.respondId
                }
            });
        }

        function clearTypingState() {
            if (!helperService.getIsRedesign()) {
                return;
            }

            if (self.isTyping) {
                self.isTyping = false;
                self.sendTypingStateToServer();
            }
        }

        function onAttendeesTypingListUpdated(e, data) {
            if (!helperService.getIsRedesign()) {
                return;
            }

            if (data && data.attendeesTyping) {
                //Exclude self from typing list
                if (data.attendeesTyping.hasOwnProperty(self.attendantId)) {
                    delete data.attendeesTyping[self.attendantId];
                }

                self.attendeesTyping = data.attendeesTyping;
                digest();
            }
        }

        function getLengthOfAttendeesTypingList() {
            return Object.keys(self.attendeesTyping).length;
        }

        function getFirstMemberOfAttendeesTypingList() {
            if (Object.keys(self.attendeesTyping).length > 0) {
                return self.attendeesTyping[Object.keys(self.attendeesTyping)[0]];
            } else {
                return null;
            }
        }

        function onWebinarOptionsUpdated() {
            var privateChatValueChanged = self.privateChatOnly !== meetingService.getWebinarOptions().privateChatOnly;

            if (!attendeeService.getIsPresenter() && privateChatValueChanged) {
                self.privateChatOnly = meetingService.getWebinarOptions().privateChatOnly;

                if (self.privateChatOnly) {
                    self.lastPrivateChatValue = self.privateChat;
                    self.privateChat = true;
                } else {
                    self.privateChat = self.lastPrivateChatValue;
                }

                digest();
            }
        }

        function orderByHostsOnTopThenAlpha(attendee) {
            //Pins self to top, then orders alphabetically for everyone else
            if (attendee.attendeeType === 'host') {
                return 1 + attendee.screenName;
            } else if (attendee.attendeeType === 'presenter') {
                return 2 + attendee.screenName;
            } else {
                return 3 + attendee.screenName;
            }
        }

        function chatFocused() {
            inputService.incrementInputFocused();
        }

        function chatBlurred() {
            inputService.decrementInputFocused();
        }

        function digest() {
            $scope.$applyAsync();
        }

        function generateCustomMessage(msgObj, index) {
            if (!msgObj) {
                logger.error('generateCustomMessage', 'invalid msgObj');
                return;
            }

            var msgClass = self.getMessageClass(msgObj, index);

            var lastElement = $window.$('#chat-list li').last();
            if (msgClass.indexOf('continued') > -1) {
                if (!lastElement.hasClass('continued')) {
                    //Add 'first-of-continued' class to previous message if it is the first of a message thread
                    lastElement.addClass('first-of-continued');
                }
            } else if (lastElement.hasClass('continued')) {
                //If previous message is continued, but current message is not,
                //previous message is the last of its thread
                lastElement.removeClass('continued').addClass('last-of-continued');
            }

            var data = {
                msgObj: msgObj,
                index: index,
                msgClass: msgClass,
                helperFunctions: {
                    setResponse: self.setResponse,
                    clearResponse: self.clearResponse,
                    onDownloadClick: self.onDownloadClick
                }
            };

            if (meetingService.isWebinar()) {
                data.webinarPrivateData = {
                    showMsgResponse: self.showMessageResponse(msgObj, index),
                    privateNameDisplay: self.getPrivateNameDisplay(msgObj)
                };
            } else if (meetingService.getMeetingPrivateChatEnabled()) {
                data.meetingPrivateData = {
                    isSender: !!(
                        msgObj.id === self.attendantId ||
                        (msgObj.userIdentifier &&
                            self.userIdentifier &&
                            msgObj.userIdentifier === self.userIdentifier) ||
                        (msgObj.userIdentifier && self.email && msgObj.userIdentifier === self.email) ||
                        (msgObj.email && self.email && msgObj.email === self.email)
                    ),
                    isRecipient: isCurrentUserRecipient(msgObj.respondId),
                    respondantName: self.getMessageRespondantName(msgObj),
                    senderSupportsPrivateMeetingChat: msgObj.senderSupportsPrivateMeetingChat
                };
            }

            // TODO: check for and remove msgObj.content if messageContent is not allowed.
            // For now this does not work, because it will hide content from history msg also.

            var customMessage = customChatService.generateCustomMessage(data);
            $('#chat-list').append(customMessage);
        }

        function clearCustomChatList() {
            $('#chat-list').html('');
        }

        function refreshCustomChatList() {
            self.clearCustomChatList();

            socketService.send({
                message: 'chat-history',
                callback: function (chatList) {
                    self.setMessagesArray(chatList);
                    self.scrollToBottom();
                }
            });
        }

        function setMessagesArray(messages) {
            self.messages = self.filterChatNotificationForWebinarAttendee(messages);
            self.messages.forEach(function (msg, index) {
                if (msg.translation && msg.translation.key) {
                    msg.message = self.notificationTranslationService.translateNotification(msg);
                }
                self.generateCustomMessage(msg, index);
            });
        }

        function hasScrollBarInChat() {
            return helperService.hasScrollBar('#chat .chat-list');
        }

        function onE2EEEnabled(e, data) {
            self.clearTypingState();
            self.chatText = '';
            $rootScope.$broadcast('cleared-meeting-chat-messages');
        }

        function canClearMeetingChat() {
            return attendeeService.getIsHost();
        }
    }
]);
